export const PUBLIC_REFERRAL_ACCESS_QUERY_KEY = 'public-referral-access';
export const PUBLIC_REFERRAL_MESSAGES_QUERY_KEY = 'public-referral-messages';
export const PUBLIC_REFERRAL_DOCUMENTS_QUERY_KEY = 'public-referral-documents';

export function hashPublicTokenForQueryKey(token: string | undefined) {
  if (!token) {
    return '';
  }

  let hash = 2166136261;
  for (let index = 0; index < token.length; index += 1) {
    hash ^= token.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  return `t_${(hash >>> 0).toString(16)}`;
}

export function getPublicReferralAccessQueryKey(
  invitationToken: string | undefined,
  sessionToken: string | undefined
) {
  return [
    PUBLIC_REFERRAL_ACCESS_QUERY_KEY,
    hashPublicTokenForQueryKey(invitationToken),
    hashPublicTokenForQueryKey(sessionToken)
  ];
}

export function getPublicReferralMessagesQueryKey(
  invitationToken: string | undefined,
  sessionToken: string | undefined,
  referralId: string | undefined
) {
  return [
    PUBLIC_REFERRAL_MESSAGES_QUERY_KEY,
    hashPublicTokenForQueryKey(invitationToken),
    hashPublicTokenForQueryKey(sessionToken),
    referralId ?? null
  ];
}

export function getPublicReferralDocumentsQueryKey(
  invitationToken: string | undefined,
  sessionToken: string | undefined,
  referralId: string | undefined
) {
  return [
    PUBLIC_REFERRAL_DOCUMENTS_QUERY_KEY,
    hashPublicTokenForQueryKey(invitationToken),
    hashPublicTokenForQueryKey(sessionToken),
    referralId ?? null
  ];
}
